// From: https://en.wikipedia.org/wiki/Glossary_of_contract_bridge_terms#top
// Seat
// Position relative to the dealer: for example, dealer's LHO is said to be in second seat.
// LHO
// Left-hand opponent
//

// Bidder
// partner
// declarer
const SEATS = {
	N: { name: 'North', short: 'N', partner: 'S', pair: 'NS', left: 'E' },
	S: { name: 'South', short: 'S', partner: 'N', pair: 'NS', left: 'W' },
	E: { name: 'East', short: 'E', partner: 'W', pair: 'EW', left: 'S' },
	W: { name: 'West', short: 'W', partner: 'E', pair: 'EW', left: 'N' },
};

/**
 * Class representing a Seat at the Bridge Table e.g. `new Seat("N"); // North seat`
 * @param  {String} name of seat one of `NSEW`;
 */
class Seat {
	constructor(name) {
		this.seat = SEATS[name];
	}

	/**
	 * String reprentation of the instance - e.g. `North`
	 * @return {String} the Name of the seat
	 */
	toString() {
		return this.seat.name;
	}

	/**
	 * Name of the seat
	 * @return {String}  the full name of the seat
	 */
	get name() {
		return this.seat.name;
	}

	/**
	 * The partnet of the seat - e.g. `N`
	 * @return {String} the identifier for the partner seat `
	 */
	get partner() {
		return this.seat.partner;
	}

	get pair() {
		return this.seat.pair;
	}

	get left() {
		return this.seat.left;
	}

	/**
	 * Identifier for the seat, e.g. `"N"`
	 *
	 * @return {String} e.g. `"N"`
	 */
	get shortName() {
		return this.seat.short;
	}
}

/**
 * constant SEATS like  `	N: { name: "North", short: "N", partner: "S" },`
 * @type {Object}
 */
Seat.SEATS = SEATS;

module.exports = Seat;
